import React from 'react';
import { cn } from '../../lib/cn';

export function SectionLabel({ children, right, className }) {
  return (
    <div className={cn('flex items-center justify-between', className)}>
      <span className="text-[10.5px] font-semibold text-ink-3 uppercase tracking-[0.08em]">
        {children}
      </span>
      {right}
    </div>
  );
}

export default SectionLabel;
